import styled from 'styled-components';
import React from 'react';

const panelColors = {
	SIU: {
		blue: {
			top: `
				background: linear-gradient(45deg, rgba(62,104,200,1) 0%, rgba(105,159,232,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #8dbff0, inset 0vw -0.10vh 0.17vh 0 #8dbff0;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(55,93,181,1) 0%, rgba(49,85,168,1) 8%, rgba(40,72,146,1) 20%, rgba(29,54,112,1) 40%, rgba(32,58,120,1) 60%, rgba(40,72,146,1) 85%, rgba(49,85,168,1) 92%, rgba(55,93,181,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.4), inset 0vw -0.14vh 0.14vh 0 #477acc;
			`,
			well: `
				background: linear-gradient(180deg, rgba(21,43,101,1) 10%, rgba(47,66,162,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #a4c9f3;	
			`
		},
		teal: {
			top: `
				background: linear-gradient(45deg, rgba(4,129,137,1) 0%, rgba(5,184,196,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #07d0d8, inset 0vw -0.17vh 0.17vh 0 #07d0d8;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(4,145,155,1) 0%, rgba(4,129,137,1) 8%, rgba(15,111,118,1) 15%, rgba(15,90,95,1) 35%, rgba(15,90,95,1) 65%, rgba(15,111,118,1) 85%, rgba(4,129,137,1) 92%, rgba(4,145,155,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.4), inset 0vw -0.14vh 0.14vh 0 #06b3b8;
			`,
			well: `
				background: linear-gradient(180deg, rgba(15,84,89,1) 10%, rgba(4,120,127,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #3ec8d1;			
			`
		},
		yellow: {
			top: `
				background: linear-gradient(45deg, rgba(255,156,60,1) 0%, rgba(252,201,67,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #fdde5d, inset 0vw -0.17vh 0.17vh 0 #fdde5d;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(221,112,53,1) 0%, rgba(182,84,31,1) 8%, rgba(158,71,25,1) 15%, rgba(158,71,25,1) 85%, rgba(182,84,31,1) 92%, rgba(221,112,53,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.4), inset 0vw -0.14vh 0.14vh 0 #e89746;
			`,
			well: `
				background: linear-gradient(180deg, rgba(141,61,17,1) 10%, rgba(205,94,32,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #ffd574;				
			`
		},
		red: {
			top: `
				background: linear-gradient(45deg, rgba(181,45,21,1) 0%, rgba(234,65,42,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #ff5c38, inset 0vw -0.17vh 0.17vh 0 #ff401f;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(163,40,17,1) 0%, rgba(136,38,19,1) 8%, rgba(122,35,18,1) 15%, rgba(111,32,17,1) 35%, rgba(111,32,17,1) 65%, rgba(122,35,18,1) 85%, rgba(136,38,19,1) 92%, rgba(163,40,17,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.4), inset 0vw -0.14vh 0.14vh 0 #c03314;				
			`,
			well: `
				background: linear-gradient(180deg, rgba(102,16,0,1) 10%, rgba(168,27,0,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #f5513c;				
			`
		},
		green: {
			top: `
				background: linear-gradient(45deg, rgba(0,142,91,1) 0%, rgba(0,216,137,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #00e0ad, inset 0vw -0.17vh 0.17vh 0 #00c790;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(0,142,91,1) 0%, rgba(0,118,77,1) 8%, rgba(0,90,59,1) 35%, rgba(0,90,59,1) 65%, rgba(0,118,77,1) 92%, rgba(0,142,91,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.4), inset 0vw -0.14vh 0.14vh 0 #00a56b;				
			`,
			well: `
				background: linear-gradient(180deg, rgba(0,77,50,1) 10%, rgba(0,106,69,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #0de09f;				
			`
		},
		gray: {
			top: `
				background: linear-gradient(45deg, rgba(131,131,131,1) 0%, rgba(173,173,173,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #c6c6c6, inset 0vw -0.17vh 0.17vh 0 #b8b7b7;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(118,118,118,1) 0%, rgba(70,70,70,1) 50%, rgba(118,118,118,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.4), inset 0vw -0.14vh 0.14vh 0 #8e8e8e;
			`,
			well: `
				background: linear-gradient(180deg, rgba(64,64,64,1) 10%, rgba(84,84,84,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #c5c5c5;				
			`
		},
		purple: {
			top: `
				background: linear-gradient(45deg, rgba(107,73,186,1) 0%, rgba(147,104,226,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #b88aec, inset 0vw -0.17vh 0.17vh 0 #b88aec;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(115,75,207,1) 0%, rgba(91,56,171,1) 10%, rgba(72,45,133,1) 35%, rgba(72,45,133,1) 65%, rgba(91,56,171,1) 90%, rgba(115,75,207,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.4), inset 0vw -0.14vh 0.14vh 0 #9a64de;
			`,
			well: `
				background: linear-gradient(180deg, rgba(57,35,108,1) 10%, rgba(84,51,160,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #ab8ede;				
			`
		},
		black: {
			top: `
				background: linear-gradient(45deg, rgba(39,39,39,1) 0%, rgba(69,69,69,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #616161, inset 0vw -0.08vh 0.17vh 0 #757575;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(44,44,44,1) 0%, rgba(28,28,28,1) 35%, rgba(28,28,28,1) 65%, rgba(44,44,44,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.4), inset 0vw -0.14vh 0.14vh 0 #3b3b3b;
			`,
			well: `
				background: linear-gradient(180deg, rgba(28,28,28,1) 10%, rgba(47,47,47,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #555555;				
			`
		},
		gold: {
			top: `
				background: linear-gradient(45deg, rgba(240,95,24,1) 0%, rgba(255,144,36,1) 40%, rgba(255,240,63,1) 80%, rgba(255,244,110,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #fffbb8, inset 0vw -0.17vh 0.17vh 0 #fff760;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(218,81,8,1) 0%, rgba(190,62,7,1) 20%, rgba(148,40,3,1) 40%, rgba(177,59,7,1) 60%, rgba(217,99,11,1) 80%, rgba(228,158,22,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #f6a011;
			`,
			well: `
				background: linear-gradient(180deg, rgba(148,40,3,1) 0%, rgba(240,95,24,1) 50%, rgba(255,144,36,1) 100%);
				box-shadow: 0vw 0.1vh 0 0 #fffcd8;
			`
		},
		silver: {
			top: `
				background: linear-gradient(45deg, rgba(118,118,118,1) 0%, rgba(145,145,145,1) 50%, rgba(195,195,195,1) 80%, rgba(217,217,217,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #eeeded, inset 0vw -0.17vh 0.17vh 0 #dfdede;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(114,114,114,1) 0%, rgba(68,68,68,1) 15%, rgba(50,50,50,1) 35%, rgba(50,50,50,1) 65%, rgba(68,68,68,1) 85%, rgba(114,114,114,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #797979;
			`,
			well: `
				background: linear-gradient(180deg, rgba(61,61,61,1) 0%, rgba(87,87,87,1) 50%, rgba(129,129,129,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #ffffff;
			`
		},
		bronze: {
			top: `
				background: linear-gradient(45deg, rgba(191,73,31,1) 0%, rgba(211,94,45,1) 50%, rgba(247,151,67,1) 80%, rgba(252,214,123,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #fef2ce, inset 0vw -0.17vh 0.17vh 0 #fef0af;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(192,72,35,1) 0%, rgba(140,43,28,1) 20%, rgba(118,28,13,1) 40%, rgba(118,28,13,1) 60%, rgba(140,43,28,1) 80%, rgba(192,72,35,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #e95535;
			`,
			well: `
				background: linear-gradient(180deg, rgba(129,28,13,1) 0%, rgba(163,46,12,1) 50%, rgba(206,99,51,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #fde7b8;
			`
		},
		copper: {
			top: `
				background: linear-gradient(45deg, rgba(129,45,37,1) 0%, rgba(149,62,50,1) 50%, rgba(207,110,76,1) 80%, rgba(245,181,129,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #fde6d0, inset 0vw -0.17vh 0.17vh 0 #fccb8c;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(128,46,40,1) 0%, rgba(97,34,36,1) 20%, rgba(73,24,26,1) 40%, rgba(73,24,26,1) 60%, rgba(97,34,36,1) 80%, rgba(128,46,40,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #992e32;
			`,
			well: `
				background: linear-gradient(180deg, rgba(85,20,22,1) 0%, rgba(103,23,18,1) 50%, rgba(149,67,55,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #f8d5bb;
			`
		}
	},
	HRDP: {
		blue: {
			top: `
				background: linear-gradient(45deg, rgba(59,57,168,1) 0%, rgba(102,113,242,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #9eadf9, inset 0vw -0.17vh 0.17vh 0 #9eadf9;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(70,67,185,1) 0%, rgba(47,45,138,1) 8%, rgba(22,39,118,1) 15%, rgba(26,39,103,1) 50%, rgba(22,45,157,1) 90%, rgba(102,113,242,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.3), inset 0vw -0.14vh 0.14vh 0 #4f71eb;				
			`,
			well: `
				background: linear-gradient(180deg, rgba(16,27,76,1) 0%, rgba(57,53,156,1) 100%);
				box-shadow: 0vw 0.1vh 0 0 #a2a9fa;				
			`
		},
		teal: {
			top: `
				background: linear-gradient(45deg, rgba(0,116,76,1) 0%, rgba(0,190,143,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #00dec7, inset 0vw -0.17vh 0.17vh 0 #00dec5;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(0,124,84,1) 0%, rgba(0,96,65,1) 8%, rgba(0,78,52,1) 15%, rgba(0,53,36,1) 50%, rgba(0,78,52,1) 85%, rgba(0,96,65,1) 92%, rgba(0,124,84,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.3), inset 0vw -0.14vh 0.14vh 0 #00ab74;		
			`,
			well: `
				background: linear-gradient(180deg, rgba(0,53,36,1) 0%, rgba(0,89,60,1) 100%);
				box-shadow: 0vw 0.1vh 0 0 #6dcfb7;
			`
		},
		yellow: {
			top: `
				background: linear-gradient(45deg, rgba(171,128,0,1) 0%, rgba(238,193,51,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #f7e14e, inset 0vw -0.17vh 0.17vh 0 #f7e14e;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(202,158,20,1) 0%, rgba(173,116,0,1) 8%, rgba(150,96,0,1) 15%, rgba(100,67,0,1) 50%, rgba(150,96,0,1) 85%, rgba(173,116,0,1) 92%, rgba(202,158,20,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.3), inset 0vw -0.14vh 0.14vh 0 #e8cd03;
			`,
			well: `
				background: linear-gradient(180deg, rgba(65,43,0,1) 0%, rgba(143,91,0,1) 100%);
				box-shadow: 0vw 0.1vh 0 0 #ffd655;
			`
		},
		red: {
			top: `
				background: linear-gradient(45deg, rgba(144,32,18,1) 0%, rgba(228,62,64,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #ed5355, inset 0vw -0.17vh 0.17vh 0 #ed5355;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(149,50,37,1) 0%, rgba(132,42,27,1) 8%, rgba(103,31,20,1) 15%, rgba(70,23,15,1) 50%, rgba(132,42,27,1) 85%, rgba(159,54,42,1) 92%, rgba(210,76,71,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #e35c49;
			`,
			well: `
				background: linear-gradient(180deg, rgba(60,14,9,1) 0%, rgba(131,28,15,1) 100%);
				box-shadow: 0vw 0.1vh 0 0 #ff6869;
			`
		},
		green: {
			top: `
				background: linear-gradient(45deg, rgba(0,133,70,1) 0%, rgba(0,190,97,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #00dc8c, inset 0vw -0.17vh 0.17vh 0 #00dc8c;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(0,140,76,1) 0%, rgba(0,103,45,1) 8%, rgba(0,89,16,1) 15%, rgba(0,68,17,1) 50%, rgba(0,89,16,1) 85%, rgba(0,103,45,1) 92%, rgba(0,140,76,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #00ac47;
			`,
			well: `
				background: linear-gradient(180deg, rgba(0,68,17,1) 0%, rgba(0,102,44,1) 100%);
				box-shadow: 0vw 0.1vh 0 0 #06ee97;
			`
		},
		gray: {
			top: `
				background: linear-gradient(45deg, rgba(101,101,101,1) 0%, rgba(151,151,151,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #cfcece, inset 0vw -0.17vh 0.17vh 0 #cfcece;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(114,114,114,1) 0%, rgba(68,68,68,1) 15%, rgba(50,50,50,1) 50%, rgba(75,75,75,1) 85%, rgba(115,115,115,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #a7a7a7;
			`,
			well: `
				background: linear-gradient(180deg, rgba(44,44,44,1) 0%, rgba(87,87,87,1) 100%);
				box-shadow: 0vw 0.1vh 0 0 #d6d6d6;
			`
		},
		purple: {
			top: `
				background: linear-gradient(45deg, rgba(103,37,180,1) 0%, rgba(166,109,231,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #dbadf5, inset 0vw -0.17vh 0.17vh 0 #c599f0;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(103,37,180,1) 0%, rgba(63,21,124,1) 12%, rgba(37,14,83,1) 45%, rgba(37,14,83,1) 65%, rgba(63,21,124,1) 88%, rgba(103,37,180,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #9231ec;
			`,
			well: `
				background: linear-gradient(180deg, rgba(37,14,83,1) 0%, rgba(124,61,197,1) 100%);
				box-shadow: 0vw 0.1vh 0 0 #d1a9ff;
			`
		},
		plum: {
			top: `
				background: linear-gradient(45deg, rgba(56,27,106,1) 0%, rgba(83,42,157,1) 65%, rgba(108,60,195,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #b765ec, inset 0vw -0.17vh 0.17vh 0 #aa58ed;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(79,40,148,1) 0%, rgba(56,27,106,1) 20%, rgba(45,18,92,1) 40%, rgba(45,18,92,1) 60%, rgba(56,27,106,1) 80%, rgba(99,52,183,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #9b51ec;
			`,
			well: `
				background: linear-gradient(180deg, rgba(40,14,86,1) 0%, rgba(56,27,106,1) 50%, rgba(82,41,156,1) 100%);
				box-shadow: 0vw 0.1vh 0 0 #a67af6;
			`
		},
		lavender: {
			top: `
				background: linear-gradient(45deg, rgba(116,83,160,1) 0%, rgba(152,103,175,1) 50%, rgba(173,132,193,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #d9c5e2, inset 0vw -0.17vh 0.17vh 0 #d9c5e2;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(116,83,160,1) 0%, rgba(71,47,135,1) 8%, rgba(56,44,106,1) 15%, rgba(37,29,71,1) 50%, rgba(56,44,106,1) 85%, rgba(71,47,135,1) 92%, rgba(116,83,160,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #8e60e8;
			`,
			well: `
				background: linear-gradient(180deg, rgba(37,29,71,1) 0%, rgba(89,61,146,1) 100%);
				box-shadow: 0vw 0.1vh 0 0 #e5aeff;
			`
		},
		black: {
			top: `
				background: linear-gradient(45deg, rgba(23,23,23,1) 0%, rgba(65,65,65,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #686767, inset 0vw -0.17vh 0.17vh 0 #737272;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(35,35,35,1) 0%, rgba(26,26,26,1) 12%, rgba(15,15,15,1) 50%, rgba(40,40,40,1) 88%, rgba(65,65,65,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #494949;
			`,
			well: `
				background: linear-gradient(180deg, rgba(15,15,15,1) 0%, rgba(37,37,37,1) 100%);
				box-shadow: 0vw 0.1vh 0 0 #808080;
			`
		},
		pink: {
			top: `
				background: linear-gradient(45deg, rgba(187,69,108,1) 0%, rgba(219,121,158,1) 65%, rgba(245,154,185,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #fcdee8, inset 0vw -0.17vh 0.17vh 0 #f4a3e2;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(203,96,135,1) 0%, rgba(173,60,98,1) 20%, rgba(128,37,75,1) 40%, rgba(128,37,75,1) 60%, rgba(173,60,98,1) 80%, rgba(217,118,155,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #f5bae8;
			`,
			well: `
				background: linear-gradient(180deg, rgba(92,22,51,1) 0%, rgba(187,69,108,1) 100%);
				box-shadow: 0vw 0.1vh 0 0 #ffccdd;
			`
		},
		gold: {
			top: `
				background: linear-gradient(45deg, rgba(240,95,24,1) 0%, rgba(255,144,36,1) 40%, rgba(255,240,63,1) 80%, rgba(255,244,110,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #fffbb8, inset 0vw -0.17vh 0.17vh 0 #fff760;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(218,81,8,1) 0%, rgba(190,62,7,1) 20%, rgba(148,40,3,1) 40%, rgba(177,59,7,1) 60%, rgba(217,99,11,1) 80%, rgba(228,158,22,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #f6a011;
			`,
			well: `
				background: linear-gradient(180deg, rgba(148,40,3,1) 0%, rgba(240,95,24,1) 50%, rgba(255,144,36,1) 100%);
				box-shadow: 0vw 0.1vh 0 0 #fffcd8;
			`
		},
		silver: {
			top: `
				background: linear-gradient(45deg, rgba(118,118,118,1) 0%, rgba(145,145,145,1) 50%, rgba(195,195,195,1) 80%, rgba(217,217,217,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #eeeded, inset 0vw -0.17vh 0.17vh 0 #dfdede;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(114,114,114,1) 0%, rgba(68,68,68,1) 15%, rgba(50,50,50,1) 35%, rgba(50,50,50,1) 65%, rgba(68,68,68,1) 85%, rgba(114,114,114,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #797979;
			`,
			well: `
				background: linear-gradient(180deg, rgba(61,61,61,1) 0%, rgba(87,87,87,1) 50%, rgba(129,129,129,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #ffffff;
			`
		},
		bronze: {
			top: `
				background: linear-gradient(45deg, rgba(191,73,31,1) 0%, rgba(211,94,45,1) 50%, rgba(247,151,67,1) 80%, rgba(252,214,123,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #fef2ce, inset 0vw -0.17vh 0.17vh 0 #fef0af;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(192,72,35,1) 0%, rgba(140,43,28,1) 20%, rgba(118,28,13,1) 40%, rgba(118,28,13,1) 60%, rgba(140,43,28,1) 80%, rgba(192,72,35,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #e95535;
			`,
			well: `
				background: linear-gradient(180deg, rgba(129,28,13,1) 0%, rgba(163,46,12,1) 50%, rgba(206,99,51,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #fde7b8;
			`
		},
		copper: {
			top: `
				background: linear-gradient(45deg, rgba(129,45,37,1) 0%, rgba(149,62,50,1) 50%, rgba(207,110,76,1) 80%, rgba(245,181,129,1) 100%);
				box-shadow: inset 0vw 0.14vh 0.14vh 0 #fde6d0, inset 0vw -0.17vh 0.17vh 0 #fccb8c;
			`,
			bottom: `
				background: linear-gradient(90deg, rgba(128,46,40,1) 0%, rgba(97,34,36,1) 20%, rgba(73,24,26,1) 40%, rgba(73,24,26,1) 60%, rgba(97,34,36,1) 80%, rgba(128,46,40,1) 100%);
				box-shadow: 0vw 0.2vh 0.28vh 0 rgba(0,0,0,0.5), inset 0vw -0.14vh 0.14vh 0 #992e32;
			`,
			well: `
				background: linear-gradient(180deg, rgba(85,20,22,1) 0%, rgba(103,23,18,1) 50%, rgba(149,67,55,1) 90%);
				box-shadow: 0vw 0.1vh 0 0 #f8d5bb;
			`
		}
	}
}
export const Item = styled(p => { return (
	<div className={p.className} onClick={p.onClick} style={p.style} id={p.id}>
		<div className='bottom'>
			<div className='top'>
				{p.children}
			</div>
		</div>
	</div>
)})`${p => {
	const color = panelColors[ 'SIU'][p.color || 'blue'] || panelColors.SIU.blue;
	return `
		width: 100vw;
		height: 23vw;
		box-sizing: border-box;
		padding: 0 1vw;
		flex: 0 0 auto;
		margin-bottom: 1vw;

		& > .bottom {
			padding: 0;
			border-radius: 1.55vw;
			height: 100%;
			width: 100%;
			${color.bottom};

			& > .top {
				position: relative;
				border-radius: 1.55vw;
				display: flex;
				align-items: stretch;
				justify-content: center;
				padding: ${p.pad || '2vw 3vw'};
				height: calc(100% - 1.5vw);
				box-sizing: border-box;
				${color.top};
			}
		}
	`
}}`;


export const Well = styled(p => {return (
	<div className={p.className} onClick={p.onClick}>
		{p.children}
	</div>
)})`
	border-radius: 1.55vw;
	font-size: ${p => p.fs || 4}vw;
	letter-spacing: 0.2vw;
	display: flex;
	width: fit-content;
	align-items: center;
	${p => (panelColors[ 'SIU'][p.color || 'blue']  || panelColors.SIU.blue).well};
`;
